const CURRENT_COMPANY_ID = "CurrentCompanyId";

export const mapGroupCompanyOptions = (groupCompanies = []) =>
  groupCompanies.map((m) => ({
    id: m.Id,
    name: m.Name,
    vendorType: m.VendorType,
    color: "bg-brand" + m.VendorType,
    webpageUrl: m.WebpageUrl ?? null,
  }));

export const findCompanyOption = (options = [], companyId) =>
  options.find((o) => String(o.id) === String(companyId));

export class CurrentCompanyStorage {
    static saveCurrentCompanyId = (companyId) => {
        if (typeof window === "undefined") return;
        window.localStorage.setItem(CURRENT_COMPANY_ID, companyId);
    };

    static getCurrentCompanyId = () => {
        if (typeof window === "undefined") return null;
        return window.localStorage.getItem(CURRENT_COMPANY_ID);
    };
}
